import axios from 'axios';
import React from 'react';
import { useContext } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import UserContext from '../../UserContext';
import { ErrorAlert, SuccessAlert } from '../../utils/Alerts';
import Support from './Support';

const SupportContainer = () => {
  const { setCurrentMenuItem, user } = useContext(UserContext);
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [subject, setSubject] = useState('');
  const [files, setFiles] = useState([]);
  const [previewFiles, setPreviewFiles] = useState([]);
  const [submitButtonText, setSubmitButtonText] = useState('отправить');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    setCurrentMenuItem('support');
  }, [])

  useEffect(() => {
    if (!files.length) {
      setPreviewFiles([])
      return
    }

    let tempPreviewsArray = [];
    files.forEach((item) => {
      const objectUrl = URL.createObjectURL(item);
      tempPreviewsArray = [...tempPreviewsArray, objectUrl];
    });
    setPreviewFiles(tempPreviewsArray);
  }, [files])

  useEffect(() => {
    if (submitButtonText === 'отправлено') {
      setTimeout(() => {
        setSubmitButtonText('отправить');
        setSubject('');
        setMessage('');
        setEmail('');
        setFiles([]);
        setPreviewFiles([]);
      }, 6000);
    }
  }, [submitButtonText])

  const onHandleFileUpload = (e) => {
    e.preventDefault();
    const filesArray = e.target.files;
    const filesArr = Array.prototype.slice.call(filesArray);
    setFiles([...files, ...filesArr]);
  }

  const handleRemoveFile = (e) => {
    const tempFilesArray = files.filter((item) => item !== e);
    setFiles(tempFilesArray);
  }

  const onSubmitForm = (e) => {
    e.preventDefault();
    const url = `${process.env.REACT_APP_API}api/v1.0/support/email`;
    const data = {
      Email: email,
      Subject: subject,
      Message: message,
      TechInfo: `Письмо с сайта ККБ-2. Support.
${navigator.appName}, ${navigator.appVersion}
Location: ${window.location}`,
      PersonFio: `${user?.lastName} ${user?.firstName} ${user?.middleName}`,
      PersonPhone: sessionStorage.getItem('forgot_userName'),
    }

    let formData = new FormData();
    for (let key in data) {
      formData.append(key, data[key]);
    }
    for (let i = 0; i < files.length; i++) {
      formData.append(`files`, files[i], files[i]?.name);
    }

    const config = {
      headers: {
        'content-type': 'multipart/form-data',
        accept: "*/*",
        "Accept-Language": "ru-RU",
        Project: "Medis",
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      }
    }
    axios.post(url, formData, config)
      .then((res) => {
        setSubmitButtonText('отправлено');
        setSuccessMessage('Сообщение отправлено. Спасибо за обращение!');
        // setIsLoadingSuccess();
      })
      .catch((err) => {
        let errorString;
        for (const key in err?.response?.data) {
          if (Object.hasOwnProperty.call(err?.response?.data, key)) {
            const element = err?.response?.data[key];
            errorString = `${key}: ${element.join(', ')}`
          }
        }
        setErrorMessage(JSON.stringify(errorString));
      })
  }

  return (
    <>
      {successMessage && <SuccessAlert successMessage={successMessage} setSuccessMessage={setSuccessMessage} />}
      {errorMessage && <ErrorAlert errorMessage={errorMessage} setErrorMessage={setErrorMessage} />}
      <Support
        email={email}
        message={message}
        subject={subject}

        setEmail={setEmail}
        setMessage={setMessage}
        setSubject={setSubject}

        files={files}
        onHandleFileUpload={onHandleFileUpload}
        handleRemoveFile={handleRemoveFile}
        previewFiles={previewFiles}

        submitButtonText={submitButtonText}
        onSubmitForm={onSubmitForm}
      />
    </>
  )
}

export default SupportContainer;
